// extracted by mini-css-extract-plugin
module.exports = {"label":"EmployeesList_label__9kwA1","date":"EmployeesList_date__2v6IW","container":"EmployeesList_container__3EyQ8"};